module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "z-task-checklist"
  }, [_c('div', {
    staticClass: "z-checklist__add-btn",
    on: {
      "click": _vm.addItem
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$props.label))]), _c('md-icon', {
    staticClass: "small"
  }, [_vm._v("add")])], 1), (_vm.val && _vm.val.length) ? _c('div', {
    staticClass: "z-task-checklist-container"
  }, _vm._l((_vm.val), function(list, i) {
    return _c('div', {
      key: i,
      staticClass: "z-checklist"
    }, [_c('div', {
      staticClass: "z-checklist__head z-hover"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (list.l),
        expression: "list.l"
      }],
      staticClass: "z-checklist__flat-input",
      attrs: {
        "placeholder": "Заголовок чеклиста..."
      },
      domProps: {
        "value": (list.l)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(list, "l", $event.target.value)
        }
      }
    }), _c('md-button', {
      staticClass: "md-icon-button md-dense close small z-task-checklist__add-btn",
      on: {
        "click": function($event) {
          _vm.removeItem(i)
        }
      }
    }, [_c('md-icon', [_vm._v("delete")])], 1)], 1), (_vm.percent[i] != undefined) ? _c('div', {
      staticClass: "z-checklist__progress"
    }, [_c('div', {
      staticClass: "z-checklist__progress__value"
    }, [_vm._v(_vm._s(Math.round(_vm.percent[i]) + '%'))]), _c('div', {
      staticClass: "z-checklist__progress__container"
    }, [_c('div', {
      staticClass: "z-checklist__progress-line",
      class: {
        'complete': parseInt(_vm.percent[i]) >= 100
      },
      style: ('width: ' + _vm.percent[i] + '%;')
    })])]) : _vm._e(), (list['i'] && list['i'].length) ? _c('div', {
      staticClass: "z-checklist__body"
    }, [_c('div', {
      staticClass: "z-checklist__container"
    }, _vm._l((list['i']), function(check, j) {
      return _c('div', {
        key: j,
        staticClass: "z-checklist__check z-hover",
        class: {
          'complete': check.c
        }
      }, [_c('div', {
        staticClass: "z-checklist__checkbox",
        class: {
          'checked': check.c
        }
      }, [_c('label', {
        attrs: {
          "for": ('check-' + i + '-' + j)
        }
      }), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (check.c),
          expression: "check.c"
        }],
        attrs: {
          "type": "checkbox",
          "id": ('check-' + i + '-' + j)
        },
        domProps: {
          "checked": Array.isArray(check.c) ? _vm._i(check.c, null) > -1 : (check.c)
        },
        on: {
          "change": function($event) {
            var $$a = check.c,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.$set(check, "c", $$a.concat([$$v])))
              } else {
                $$i > -1 && (_vm.$set(check, "c", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
              }
            } else {
              _vm.$set(check, "c", $$c)
            }
          }
        }
      })]), _c('input', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (check.a || !check.l),
          expression: "check.a || !check.l"
        }, {
          name: "model",
          rawName: "v-model",
          value: (check.l),
          expression: "check.l"
        }],
        ref: ('check-input-' + i + '-' + j),
        refInFor: true,
        staticClass: "z-checklist__flat-input",
        attrs: {
          "placeholder": "Чек"
        },
        domProps: {
          "value": (check.l)
        },
        on: {
          "blur": function($event) {
            _vm.disactivate(i, j)
          },
          "focus": function($event) {
            _vm.activate(i, j)
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(check, "l", $event.target.value)
          }
        }
      }), _c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (!check.a && check.l),
          expression: "!check.a && check.l"
        }],
        staticClass: "z-checklist__value",
        class: {
          'complete': check.c
        },
        on: {
          "click": function($event) {
            _vm.focusCheck(('check-input-' + i + '-' + j), i, j)
          }
        }
      }, [_vm._v(_vm._s(check.l))]), _c('md-button', {
        staticClass: "md-icon-button md-dense close small z-task-checklist__add-btn",
        on: {
          "click": function($event) {
            _vm.removeCheck(i, j)
          }
        }
      }, [_c('md-icon', [_vm._v("delete")])], 1)], 1)
    }))]) : _vm._e(), _c('div', {
      staticClass: "z-checklist__footer"
    }, [_c('div', {
      staticClass: "z-checklist__add-btn",
      on: {
        "click": function($event) {
          _vm.addCheck(i)
        }
      }
    }, [_c('span', [_vm._v("Добавить чек")]), _c('md-icon', {
      staticClass: "small"
    }, [_vm._v("add")])], 1)])])
  })) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b1fb8eee","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ZTaskChecklist.vue
// module id = 1238
// module chunks = 0